<template>
	<div class="mdc-card mgb-24">
		<div class="d-flex pdl-24 pdb-20 pdr-24 pdt-20 bg-documentGray align-items-center cursor-pointer" @click="isCollapsed = !isCollapsed">
			<button class="mdc-icon-button content-trigger mgt--12 mgb--12 d-flex mgl--12">
				<div class="mdc-icon-button__ripple"></div>
				<i class="material-icons t-headline12 t-color-bodyGrayA">
					{{ isCollapsed ? 'keyboard_arrow_down' : 'keyboard_arrow_up' }}
				</i>
			</button>
			<div class="pdl-20 d-flex flex-wrap justify-content-between flex-grow-1 align-items-start">
				<div class="t-body1 font-m flex-grow-1 t-color-headline-black mgb-3 mgr-24">
					{{ section && section.name }}
				</div>
				<div class="d-flex align-items-center">
					<div v-show="section.lessons.length > 0" :class="{'microdegree-lession-info': isExamPaper(section.lessons) || section.videoRunningTime }"
					     class="t-body1 t-color-bodyGrayA font-r l-spacing48 mgl-19 position-relative">
						{{ $t(section.lessons.length <= 1 ? '30216' : '30060', {str: section.lessons.length}) }}
					</div>
					<div v-if="isExamPaper(section.lessons)"
					     :class="{'microdegree-lession-info': section.videoRunningTime}"
					     class="t-body1 t-color-bodyGrayA font-r l-spacing48 mgl-19 position-relative">
						{{ $t(isExamPaper(section.lessons) <= 1 ? '30217' : '30061', {str: isExamPaper(section.lessons)}) }}
					</div>
					<div v-if="section.videoRunningTime"
					     class="t-body1 t-color-bodyGrayA font-r l-spacing48 position-relative microdegree-lession-info mgl-19">
						{{ section.videoRunningTime | timeToI18nFormat }}
					</div>
				</div>
			</div>
		</div>
		
		<div :class="isCollapsed ? 'd-none' : 'd-block'" class="detail-content">
      <div v-if="section.lessons.length <= 0">
        <lesson-tab :lessonName="noLessonSection(section.name)"></lesson-tab>
      </div>
			<div v-for="(lesson, index) in section.lessons" :key="index">
				<lesson-tab v-if="lesson.contents.lcms"
				            :lessonIcon="lessonTypeIcon(lesson.contents)"
				            :lessonName="lesson.name">
					<div slot="detailInfo">
						<div v-if="lesson.contents.lcms.type.value.includes('HTML')"
						     class="d-flex">
<!--							<div class="t-body2 t-color-signBlue font-r l-spacing45 pdr-4 cursor-pointer"-->
<!--							     @click="displayFile(lesson.contents.lcms.item.file)">-->
<!--								{{ $t('30064') }}-->
<!--							</div>-->
							<div class="t-body2 t-color-headlineBlack font-r l-spacing45 min-w-130 t-right">
								{{ lesson.contents.lcms.item.file.chunkCount + 'p' }}
							</div>
						</div>
						<div v-else>
							<div class="t-body2 t-color-headlineBlack font-r l-spacing45 min-w-130 t-right">
								{{
									lesson.contents.lcms.type.value.includes('VIDEO') ? timeFormat(lesson.videoRunningTime) : lesson.contents.lcms.item.file.chunkCount + 'p'
								}}
							</div>
						</div>
					</div>
				</lesson-tab>
				<lesson-tab v-else-if="lesson.contents.meeting"
				            :lessonIcon="lessonTypeIcon(lesson.contents)"
				            :lessonName="lesson.name">
					<div slot="detailInfo" class="t-body2 t-color-headlineBlack font-r l-spacing45 min-w-130 t-right">
						{{ lesson.contents.meeting.duration | timeToHourMinFormat }}
					</div>
				</lesson-tab>
				<lesson-tab v-else-if="lesson.contents.exam"
				            :lessonIcon="lessonTypeIcon(lesson.contents)"
				            :lessonName="lesson.contents.exam.name">
					<div slot="detailInfo"
					     class="t-body2 t-color-headlineBlack font-r l-spacing45 min-w-130 t-right">
						{{
							$t('30065', {str: lesson.contents.exam.paper.questionGroup[0] ? questionCount(lesson.contents.exam.paper.questionGroup) : 0})
						}}
					</div>
				</lesson-tab>
			</div>
		</div>
	</div>
</template>

<script>
import {utilDateMixin} from "@/mixins/dateUtil";
import LessonTab from "@/components/microDegree/view/LessonTab.vue";
import localStorageUtil from "@/utils/localStorageUtil";

export default {
	name: "Section",
	
	components: {LessonTab},
	
	props: {
		section: {
			type: Object,
			required: true
		},
		isCollapsed: {
			type: Boolean,
			required: true
		}
	},
	
	mixins: [utilDateMixin],
	
	component: {
		'lesson-tab': () => import('@/components/microDegree/view/LessonTab.vue')
	},
	
	data() {
		return {
			isCurrentCollapsed: false,
			languageInfo: localStorageUtil.getLanguageInfo()
		}
	},
	
	mounted() {
		this.isCurrentCollapsed = this.isCollapsed;
	},
	
	methods: {
		timeFormat(time) {
			return this.$options.filters.timeToDateFormat(time)
		},
		
		isExamPaper(lessons) {
			const paperLen = _.filter(lessons, lesson => {
				return lesson.resourceType.value === 'EXAM'
			})
			return paperLen.length
		},

    noLessonSection(name) {
      return this.$t('30202', {str: name});
    },

		lessonTypeIcon(val) {
			if (val.exam !== null) {
				return 'calculate'
			}
			if (val.meeting !== null) {
				return 'videocam'
			}
      if (val.lcms.learningLanguage !== null) {
        return 'code';
      }
      const valType = val.lcms.type.value;
      switch (valType) {
        case 'VIDEO':
          return 'play_circle';
        case 'PDF':
          return 'picture_as_pdf';
        case 'HTML':
        case 'INTERACTIVE_HTML':
        case 'SLIDE':
          return 'description';
        case 'EXAM':
          return 'grid_view';
        default:
          return 'description';
      }
		},
		
		questionCount(exams) {
			let totalCount = 0;
			_.each(exams, exam => {
				totalCount += exam.questions.length;
			});
			return totalCount;
		},
		
		displayFile(file) {
			this.$emit('displayFile', file);
		},
	}
}
</script>

<style scoped>
</style>
